import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import StudioHeading from '../../../StudioHeading';
import BaseHeader from '../BaseHeader';
import DiscountTabs from './DiscountTabs';
import CreateDiscountButton from './CreateDiscountButton';

interface Props {
  className?: string;
}

const SellerDiscountsHeader: FC<Props> = ({ className }) => {
  const { t } = useTranslation();

  return (
    <BaseHeader
      className={className}
      titleSlot={
        <>
          <StudioHeading>{t('studio.header.tabs.discounts')}</StudioHeading>
          {<DiscountTabs />}
        </>
      }
      actions={<CreateDiscountButton />}
    />
  );
};

SellerDiscountsHeader.displayName = 'SellerDiscountsHeader';

export default SellerDiscountsHeader;
